// Locale configuration
import type { LocaleInfo, SupportedLocale } from "../types/locale";

export const SUPPORTED_LOCALES: ReadonlyArray<LocaleInfo> = [
  { code: "en", name: "English", dir: "ltr" },
  { code: "es", name: "Español", dir: "ltr" },
  { code: "ar", name: "اَلْعَرَبِيَّةُ", dir: "rtl" },
  { code: "pl", name: "Polski", dir: "ltr" },
  { code: "sl", name: "Slovenščina", dir: "ltr" },
] as const;

export const DEFAULT_LOCALE: SupportedLocale = "en";
